import { React, Fragment, memo, useEffect } from 'react'
import { Message } from '@paypalcorp/worldready-react'
import {
  HeadingText,
  CaptionText,
  Button,
  Avatar,
  Link,
  BodyText,
} from '@paypalcorp/pp-react'
import { PRIVACY_HOME } from '../../../constants/constants'
import asASlide from '../../common/as-a-slide'
import { fptiCustomClick } from '../../../utils'
import DATAPRIVACY_FPTI from '../../../config/data-privacy-fpti'
const linkedAccountsFpti = DATAPRIVACY_FPTI.LINKED_ACCOUNTS

const TenantName = {
  Xoom: {
    img:
      'https://www.paypalobjects.com/paypal-ui/logos/svg/xoom-monogram-color.svg',
    helperText: (
      <Message
        id="dataErasure.linkedaccounts.xoomht"
        link={(innerMessage) => (
          <Link
            href={'https://help.xoom.com/s/contactsupport?language=en_US'}
            id="xoomlink"
            theme="v2"
          >
            {innerMessage}
          </Link>
        )}
      />
    ),
    displayName: 'Xoom',
  },
  iZettle: {
    img:
      'https://www.paypalobjects.com/paypal-ui/logos/svg/zettle-pp-color.svg',
    helperText: <Message id="dataErasure.linkedaccounts.ppzettleht" />,
    helperText2: (
      <Message
        id="dataErasure.linkedaccounts.zettleuklink"
        link={(innerMessage) => (
          <Link
            href={'https://www.zettle.com/privacy-portal'}
            id="uklink"
            theme="v2"
          >
            {innerMessage}
          </Link>
        )}
      />
    ),
    helperText3: (
      <Message
        id="dataErasure.linkedaccounts.zettleuslink"
        link={(innerMessage) => (
          <Link
            href={'https://www.paypal.com/us/smarthelp/contact-us/privacy'}
            id="uslink"
            theme="v2"
          >
            {innerMessage}
          </Link>
        )}
      />
    ),
    displayName: 'PayPal Zettle',
  },
  Honey: {
    img:
      'https://www.paypalobjects.com/paypal-ui/logos/svg/honey-glyph-color.svg',
    helperText: <Message id="dataErasure.linkedaccounts.honeyhelpertext" />,
    displayName: 'PayPal Honey',
  },
}

const LinkedAccounts = memo((props) => {
  const { onModalNavigate, modalParams: { linkedAccounts = [] } = {} } = props

  useEffect(() => {
    if (!linkedAccounts.length) {
      onModalNavigate(0)
    }
  }, [])

  const handleContinueClick = (event) => {
    event.preventDefault()
    fptiCustomClick(linkedAccountsFpti.CONTINUE_BTN)
    onModalNavigate(2)
  }

  const handleNotnowClick = (event) => {
    event.preventDefault()
    fptiCustomClick(linkedAccountsFpti.NOT_NOW_LINK)
    location.href = PRIVACY_HOME
  }

  return (
    <Fragment>
      <HeadingText id="dataDeletionHeader" size="lg">
        <Message id="dataErasure.linkedaccounts.header" />
      </HeadingText>

      <ul className="linked-accounts">
        {linkedAccounts.length &&
          linkedAccounts.map((item, index) => {
            return (
              <section key={index}>
                {TenantName[item.tenant_name] && (
                  <li className="tenant-list">
                    <Avatar
                      src={TenantName[item.tenant_name].img || ''}
                      className="linkedacc-img"
                      alt={item.tenant_name}
                      size="sm"
                    />
                    <section>
                      <BodyText strong>
                        {TenantName[item.tenant_name].displayName ||
                          item.tenant_name}
                      </BodyText>
                      <CaptionText className="caption-text requestForm-info-title">
                        {TenantName[item.tenant_name].helperText || ''}
                      </CaptionText>
                      {TenantName[item.tenant_name].helperText2 && (
                        <BodyText className="requestForm-info-title">
                          <span>
                            {TenantName[item.tenant_name].helperText2}
                          </span>
                          {TenantName[item.tenant_name].helperText3 && (
                            <span className="dataDeletion-contactus-info">
                              {TenantName[item.tenant_name].helperText3 || ''}
                            </span>
                          )}
                        </BodyText>
                      )}
                    </section>
                  </li>
                )}
              </section>
            )
          })}
      </ul>

      <section className="flex-center-alignment">
        <div>
          <Button
            theme="v2"
            id="submitBtn"
            onClick={handleContinueClick}
            className=""
          >
            <Message id="dataErasure.section.continue" />
          </Button>
        </div>
        <div className="requestForm-section-desc">
          <Button tertiary onClick={handleNotnowClick}>
            <Message id="dataErasure.button.notnow" />
          </Button>
        </div>
      </section>
    </Fragment>
  )
})

LinkedAccounts.displayName = 'LinkedAccounts'
export default asASlide({ position: 1 })(LinkedAccounts)
